import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";

import { convertToNumber } from "./utils/convertToNumber";

export function crossPlotLocks(states: Partial<EvaChartStates>) {
  const { locks } = states;

  const lockedYMin =
    locks?.yMin?.type === DataEnum.Reset ? undefined : locks?.yMin?.value;
  const lockedYMax =
    locks?.yMax?.type === DataEnum.Reset ? undefined : locks?.yMax?.value;
  const lockedXMin =
    locks?.xMin?.type === DataEnum.Reset ? undefined : locks?.xMin?.value;
  const lockedXMax =
    locks?.xMax?.type === DataEnum.Reset ? undefined : locks?.xMax?.value;

  const shouldXMinLockBeString =
    locks?.xMin?.type === DataEnum.Date || locks?.xMin?.type === DataEnum.Text;

  const shouldXMaxLockBeString =
    locks?.xMax?.type === DataEnum.Date || locks?.xMax?.type === DataEnum.Text;

  return {
    lockedXMin: shouldXMinLockBeString ? lockedXMin : convertToNumber(lockedXMin),
    lockedXMax: shouldXMaxLockBeString ? lockedXMax : convertToNumber(lockedXMax),
    lockedYMin: convertToNumber(lockedYMin),
    lockedYMax: convertToNumber(lockedYMax)
  };
}
